"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginationDetailsDto = instanceOfPaginationDetailsDto;
exports.PaginationDetailsDtoFromJSON = PaginationDetailsDtoFromJSON;
exports.PaginationDetailsDtoFromJSONTyped = PaginationDetailsDtoFromJSONTyped;
exports.PaginationDetailsDtoToJSON = PaginationDetailsDtoToJSON;
exports.PaginationDetailsDtoToJSONTyped = PaginationDetailsDtoToJSONTyped;
/**
 * Check if a given object implements the PaginationDetailsDto interface.
 */
function instanceOfPaginationDetailsDto(value) {
    if (!('pageNo' in value) || value['pageNo'] === undefined)
        return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined)
        return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined)
        return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined)
        return false;
    return true;
}
function PaginationDetailsDtoFromJSON(json) {
    return PaginationDetailsDtoFromJSONTyped(json, false);
}
function PaginationDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pageNo': json['pageNo'],
        'pageSize': json['pageSize'],
        'totalCount': json['totalCount'],
        'totalPages': json['totalPages'],
    };
}
function PaginationDetailsDtoToJSON(json) {
    return PaginationDetailsDtoToJSONTyped(json, false);
}
function PaginationDetailsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'pageNo': value['pageNo'],
        'pageSize': value['pageSize'],
        'totalCount': value['totalCount'],
        'totalPages': value['totalPages'],
    };
}
